import React, { useEffect, useState } from "react";
import {
  Box,
  ButtonStyled,
  DataContainerHeader,
  FormElementWrapper,
  LabelStyled,
  SeparatorBorder,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SettingsWrapper, FormDataContainer, BoxTblHead } from "./styled";
import {
  PlaceholderImg,
  Plus,
  PlusIcon,
} from "../../../components/styled/AllImages";
import { useNavigate } from "react-router-dom";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import ImageUpload from "../../../components/common/uploadFiles/imagesUpload";
import ListTable from "../../../components/common/tables/ListTable";
import { editTempADaccessColumns } from "../../../helpers/adminConstants/TableConstants";
import SelectUserModal from "../../../components/admin/Modals/SelectUser/SelectUserModal";
import AdminDirectorApi from "../../../services/api/adminDirectorApi";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import DeleteModal from "../../../components/admin/Modals/DeleteModal/DeleteModal";
import { format } from "date-fns";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { useUser } from "../../../context/userContext";
import AddSingleDepartment from "../../../components/common/modals/singleDepartmentModal/AddSingleDepartment";

const EditAdminDirector = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { fetchUserInfo } = useUser();
  const {
    register,
    handleSubmit,
    watch,
    setValue, // For setting dropdown values programmatically
    control,
    reset,
    resetField,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [showSelectUserModal, setShowSelectUserModal] = useState(false);
  const [branchesHQ, setBranchesHQ] = useState("");
  const [departments, setDepartments] = useState("");
  const selectedBranch = watch("location_id");
  const selectedDepartment = watch("department_id");
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [deleteUploadId, setDeleteUploadId] = useState(false);
  const [deleteJobId, setDeleteJobId] = useState(false);
  const [deletedTempAd, setDeletedTempAd] = useState([]);
  const [editTempADaccessRows, setEditTempADaccessRows] = useState([]);
  const [showDelete, setShowDelete] = useState(false);

  const [deleteKey, setDeleteKey] = useState(null);
  const [usersTempList, setUsersTempList] = useState([]);
  const [jobIdFile, setJobIdFile] = useState(null);
  const [idFile, setIdFile] = useState(null);

  const onDelete = (row) => {
    setDeleteKey(row.id);
    setShowDelete(true);
  };
  const handleDelete = () => {
    setEditTempADaccessRows((prevRows) =>
      prevRows.filter((row) => row.id !== deleteKey)
    );
    setDeletedTempAd((prevData) => {
      if (!prevData.includes(deleteKey)) return [...prevData, deleteKey];
    });
    setShowDelete(false);
    setDeleteKey(null); // Reset key
  };

  const handleSaveUser = (userData) => {
    const formattedUserData = {
      ...userData,
      startDate: userData.startDate
        ? format(userData.startDate, "yyyy-MM-dd")
        : null,
      endDate: userData.endDate ? format(userData.endDate, "yyyy-MM-dd") : null,
    };
    setEditTempADaccessRows((prevRows) => {
      const isDuplicate = prevRows.some(
        (row) => row.id === formattedUserData.id
      );
      if (isDuplicate) {
        toast.error("User already added.");
        return prevRows;
      }
      return [...prevRows, formattedUserData];
    });

    setShowSelectUserModal(false);
  };

  const handleInfo = (row) => {
    setShowSelectUserModal(true);
  };

  const fetchAdmDirBranchesHQ = async () => {
    try {
      const response = await AdminDirectorApi.adminDirectorBranchesHQ();
      if (response.data) {
        const branchesHQOptions = response.data.map((branch) => ({
          id: branch.id,
          name: language === "ar" ? branch.name_ar : branch.name_en,
        }));
        setBranchesHQ(branchesHQOptions);
      }
    } catch (error) {}
  };
  const fetchDepartments = async (branchId) => {
    try {
      const response = await AdminDirectorApi.adminDirectorDepartments(
        branchId
      );
      if (response.data) {
        const departmentsOptions = response.data.map((department) => ({
          id: department.id,
          name: language === "ar" ? department.name_ar : department.name_en,
        }));
        setDepartments(departmentsOptions);
      }
    } catch (error) {}
  };

  const getAdminDirectorDetails = async () => {
    try {
      const response = await AdminDirectorApi.adminDirector();
      if (response?.data) {
        reset({
          name: response?.data?.name || "",
          position: response?.data?.user_detail?.position || "",
          location_id: response?.data?.user_detail?.location_id || "",
          department_id: response?.data?.user_detail?.department_id || "",
          phone: response?.data?.phone || "",
          email: response?.data?.email || "",
          upload_job_id: response?.data?.user_detail?.upload_job_id,
          upload_id: response?.data?.user_detail?.upload_id,
        });

        const baseAssetURL = process.env.REACT_APP_ASSET_URL;
        const idUrl = response?.data?.user_detail?.upload_id
          ? `${baseAssetURL}/${response.data.user_detail.upload_id}`
          : null;
        const jobIdUrl = response?.data?.user_detail?.upload_job_id
          ? `${baseAssetURL}/${response.data.user_detail.upload_job_id}`
          : null;
        setEditTempADaccessRows(
          response?.data?.temporary_admins?.map((item) => ({
            ...item,
            id: item.user_id,
            user: {
              ...item?.user,

              image: item?.user?.profile
                ? `${baseAssetURL}/${item?.user?.profile}`
                : PlaceholderImg,
            },
            startDate: item?.start_date,
            endDate: item?.end_date,
          }))
        );
        setJobIdFile(jobIdUrl);
        setIdFile(idUrl);
      }
    } catch (error) {
    } finally {
    }
  };

  const manageLoading = async (asyncFunctions) => {
    try {
      setDataLoading(true);
      await Promise.all(asyncFunctions.map((fn) => fn()));
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    manageLoading([fetchAdmDirBranchesHQ, getAdminDirectorDetails]);
  }, [language]);

  // Update departments when the selected branch changes
  useEffect(() => {
    if (selectedBranch) {
      fetchDepartments(selectedBranch);
    } else {
      setDepartments([]);
    }
  }, [selectedBranch]);

  const onSubmit = async (formData) => {
    try {
      setLoading(true);

      const updatedData = new FormData();
      updatedData.append("action", "update");

      // Append other form data
      Object.entries(formData).forEach(([key, value]) => {
        updatedData.append(key, value);
      });

      // Format and append temporary_admins as a JSON string
      const formattedTempAdmins = editTempADaccessRows.map(
        ({ id, startDate, endDate }) => ({
          user_id: id, // Ensure 'key' corresponds to userId
          start_date: startDate,
          end_date: endDate,
        })
      );

      updatedData.append(
        "temporary_admins",
        JSON.stringify(formattedTempAdmins)
      );
      updatedData.append(
        "delete_temporary_admins",
        JSON.stringify(deletedTempAd)
      );
      updatedData.append('remove_upload_job_id', deleteJobId)
      updatedData.append('remove_upload_id', deleteUploadId)

      const response = await AdminDirectorApi.updateAdminDirector(updatedData);
      if (response.code === 200) {
        toast.success(t("admin_director_updated"));
        fetchUserInfo();
        navigate("/settings/admin-director");
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Error during submission.");
    } finally {
      setLoading(false);
    }
  };

  const getAdminsListWithoutPg = async () => {
    try {
      const { data, code } = await AdminDirectorApi.getAdminsListWithoutPg();
      if (code === 200) {
        const adminsListResponse = data || [];
        const updatedUsers = adminsListResponse?.map((user) => {
          const department =
            language === "en"
              ? user.user_detail?.department_selective?.name_en
              : user.user_detail?.department_selective?.name_ar;
          const branch =
            language === "en"
              ? user.user_detail?.office_location_selective?.name_en
              : user.user_detail?.office_location_selective?.name_ar;
          return {
            ...user,
            subLabel: `${department} (${branch})`,
          };
        });
        setUsersTempList(updatedUsers);
      }
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    getAdminsListWithoutPg();
  }, []);

  return (
    <SettingsWrapper>
      <Box className="content-head">
        <SubHeadingStyled size="16px" color="var(--text)">
          {t("settings")}
        </SubHeadingStyled>
      </Box>
      {dataLoading ? (
        <ThemeLoader />
      ) : (
        <Box className="content-container">
          <Row className="mt-3">
            <Col md={12}>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <FormDataContainer className="dataContainer">
                  <DataContainerHeader
                    backBtnLabel={t("admin_director")}
                    noBreadcrumbs=""
                    onClickBack={() => navigate("/settings/admin-director")}
                  />
                  <ValidatedInput
                    name="name"
                    type="input"
                    fieldType="text"
                    placeholder="name"
                    label="name"
                    className="combined pt-3"
                    staric="staric"
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                    }}
                  />
                  <ValidatedInput
                    name="position"
                    type="input"
                    fieldType="text"
                    placeholder="JobRole"
                    label="JobRole"
                    className="combined"
                    staric="staric"
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                    }}
                  />

                  {/* <FormElementWrapper className="combined">
                    <Box className="formEleContainer">
                      <LabelStyled className="labelForm">
                        {t("HQBranch")}
                      </LabelStyled>
                      <Box className="w-100">
                        <SelectionDropdown
                          name="location_id"
                          placeholder={t("Select")}
                          options={branchesHQ}
                          value={watch("location_id")}
                          register={register}
                          errors={errors}
                          validationRules={{
                            required: true,
                          }}
                        />
                        {errors.location_id?.type === "required" && (
                          <ValidationErrorText
                            text={
                              t(errors.location_id?.message) ||
                              t("Pleaseselectone")
                            }
                          />
                        )}
                      </Box>
                    </Box>
                  </FormElementWrapper>
                  <FormElementWrapper className="combined">
                    <Box className="formEleContainer">
                      <LabelStyled className="labelForm">
                        {t("department")}
                        <span className="staric">*</span>
                      </LabelStyled>
                      <Box className="w-100">
                        <SelectionDropdown
                          name="department_id"
                          placeholder={t("Select")}
                          options={departments}
                          value={watch("department_id")}
                          register={register}
                          errors={errors}
                          validationRules={{
                            required: true,
                          }}
                        />
                        {errors.department_id?.type === "required" && (
                          <ValidationErrorText
                            text={
                              t(errors.department_id?.message) ||
                              t("Pleaseselectone")
                            }
                          />
                        )}
                      </Box>
                    </Box>
                  </FormElementWrapper> */}

                  <Box className="info-item d-flex align-items-center formEleAddDep py-4 px-3 px-lg-4 w-100 formEleContainer">
                    <Box className="form-label">
                      <LabelStyled size="15px" color="var(--text)">{t("hq_branches")}*</LabelStyled>
                    </Box>
                    <Box>
                      <ValidationController
                        name={"location_id"}
                        control={control}
                        validationConfig={{ required: true }}
                        errors={errors}
                        renderer={({ field }) => (
                          <AddSingleDepartment
                            title={t("select_branch_hq")}
                            icon={<Plus />}
                            selPlaceholder={t("select_branch_hq")}
                            mainParents={branchesHQ}
                            selectedItem={selectedBranch}
                            setSelectedItem={(id) => field.onChange(id)}
                          />
                        )}
                      />
                    </Box>
                  </Box>
                  <Box className="info-item d-flex align-items-center formEleAddDep py-4 px-3 px-lg-4 w-100 formEleContainer">
                    <Box className="form-label">
                      <LabelStyled size="15px" color="var(--text)" >{t("department")}*</LabelStyled>
                    </Box>
                    <Box>
                      <ValidationController
                        name={"department_id"}
                        control={control}
                        validationConfig={{ required: true }}
                        errors={errors}
                        renderer={({ field }) => (
                          <AddSingleDepartment
                            title={t("select_department")}
                            icon={<Plus />}
                            selPlaceholder={t("select_department")}
                            mainParents={departments}
                            selectedItem={selectedDepartment}
                            setSelectedItem={(id) => field.onChange(id)}
                          />
                        )}
                      />
                    </Box>
                  </Box>

                  <SeparatorBorder className="mt-2" />
                  <Box className="innerFoHead">
                    <SubHeadingStyled size="16px" color="var(--text)">
                      {t("ContactDetails")}
                    </SubHeadingStyled>
                  </Box>
                  <PhoneInputField
                    name="phone"
                    label={"contact_no"}
                    placeholder={"contact_no"}
                    staric="staric"
                    className={"border-0"}
                    register={register}
                    control={control}
                    errors={errors}
                    validationRules={{
                      required: true,
                    }}
                  />
                  <ValidatedInput
                    name="email"
                    type="input"
                    fieldType="text"
                    placeholder={"Email"}
                    label="Email"
                    className="combined"
                    staric="staric"
                    errors={errors}
                    register={register}
                    validationRules={{
                      required: true,
                    }}
                  />

                  <SeparatorBorder className="mt-2" />
                  <FormElementWrapper className="combined pt-3">
                    <Box className="formEleContainer">
                      <LabelStyled className="labelForm" size="15px" color="var(--text)">
                        {t("Upload")}
                      </LabelStyled>
                      <Box className="d-flex align-items-start gap-2">
                        <ValidationController
                          name={"upload_job_id"}
                          validationConfig={{
                            required: false,
                          }}
                          errors={errors}
                          control={control}
                          renderer={({ field }) => (
                            <ImageUpload
                              UploadImage="UploadJobID"
                              setLogoDelete={setDeleteJobId}
                              onFileSelect={(file) => {
                                field.onChange(file); // Update form field
                                setJobIdFile(file); // Update logo file state
                              }}
                              initialImage={jobIdFile} // Pass the preloaded image URL
                            />
                          )}
                        />
                        <ValidationController
                          name={"upload_id"}
                          validationConfig={{
                            required: false,
                          }}
                          errors={errors}
                          control={control}
                          renderer={({ field }) => (
                            <ImageUpload
                              UploadImage="UploadID"
                              setLogoDelete={setDeleteUploadId}
                              onFileSelect={(file) => {
                                field.onChange(file); // Update form field
                                setIdFile(file); // Update logo file state
                              }}
                              initialImage={idFile} // Pass the preloaded image URL
                            />
                          )}
                        />
                      </Box>
                    </Box>
                  </FormElementWrapper>
                  <SeparatorBorder className="mt-2" />
                  <FormElementWrapper className="combined pt-3">
                    <Box className="formEleContainer">
                      <BoxTblHead>
                        <DataContainerHeader
                          label={t("TempADaccess")}
                          btnLabel="add_user"
                          icon={PlusIcon}
                          onClick={() => {
                            handleInfo();
                          }}
                        />
                        <Box className="listTableWrapper">
                          <ListTable
                            options={["delete"]}
                            rows={editTempADaccessRows}
                            columns={editTempADaccessColumns}
                            className=""
                            onDelete={onDelete}
                          />
                        </Box>
                      </BoxTblHead>
                    </Box>
                  </FormElementWrapper>
                  <SelectUserModal
                    show={showSelectUserModal}
                    onHide={() => setShowSelectUserModal(false)}
                    onSave={handleSaveUser} // Pass the save handler to the modal
                    usersList={usersTempList?.filter(
                      (item) =>
                        !editTempADaccessRows.some(
                          (row) => row?.user_id == item?.id
                        )
                    )}
                  />
                  <DeleteModal
                    show={showDelete}
                    onHide={() => setShowDelete(false)}
                    title={t("TempADaccess")}
                    onDelete={handleDelete}
                  />

                  <SeparatorBorder className="mt-2" />
                  <Box className="commonBtns w-100">
                    <ButtonStyled
                      bg="var(--bgSecondary)"
                      label={t("Cancel")}
                      color="var(--text2)"
                      type="button"
                      onClick={() => navigate("/settings/admin-director")}
                    ></ButtonStyled>
                    <ButtonStyled
                      label={t("Save")}
                      type="submit"
                      isLoading={loading}
                    ></ButtonStyled>
                  </Box>
                </FormDataContainer>
              </Form>
            </Col>
          </Row>
        </Box>
      )}
    </SettingsWrapper>
  );
};

export default EditAdminDirector;
